import { render, staticRenderFns } from "./ApprovePage.vue?vue&type=template&id=082422e5&scoped=true&"
import script from "./ApprovePage.vue?vue&type=script&lang=js&"
export * from "./ApprovePage.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePage.vue?vue&type=style&index=0&id=082422e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082422e5",
  null
  
)

export default component.exports